const __WEBPACK_NAMESPACE_OBJECT__ = require("live/components/header/ui/main/main");